export const parseSeasonYear = (season) => {
  return season && typeof season === 'string' ? season?.split(' ')?.[1] : null;
};

export const getYear = ({ season, releaseDate, releaseDateYear, releaseYear, seasonYear }: any) => {
  if (releaseYear && releaseYear.length > 0) return releaseYear;

  if (releaseDateYear && releaseDateYear.length > 0) return releaseDateYear;

  if (seasonYear && seasonYear.length > 0) return seasonYear;

  if (season) {
    return parseSeasonYear(season);
  }

  const rel = typeof releaseDate !== 'undefined' && releaseDate.toString();
  if (releaseDate) {
    return rel.slice(0, 4);
  }

  return null;
};
